import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { format, subDays } from "date-fns";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MetricTrend from "../metrics/metric-trend";
import MetricValue from "../metrics/metric-value";
import { useApiTenant } from "../../../api/api-tenant";
import { getTrendLabels, getLabels } from "../../../helpers/metrics";
import { metricColors } from "../../../helpers/colors";
export default function ContactsMetrics() {
    const { t } = useTranslation();
    const api = useApiTenant();
    const [contactsValue, setContactsValue] = useState(0);
    const [contactsValueCachedAt, setContactsValueCachedAt] = useState("");
    const [contactsValueRange, setContactsValuesRange] = useState("total");
    const [contactsValueLoading, setContactsValueLoading] = useState(true);
    const [contactsValueError, setContactsValueError] = useState(false);
    const [contactsValueStartDate, setContactsValueStartDate] = useState("");
    const [contactsValueEndDate, setContactsValueEndDate] = useState("");
    const [contactsValueStartTime, setContactsValueStartTime] = useState("");
    const [contactsValueEndTime, setContactsValueEndTime] = useState("");
    const [isChosenValueCustomRange, setIsChosenValueCustomRange] = useState(false);
    const [contactsTrendLabels, setContactsTrendLabels] = useState([]);
    const [contactsTrendValues, setContactsTrendValues] = useState([]);
    const [contactsTrendCachedAt, setContactsTrendCachedAt] = useState("");
    const [contactsTrendRange, setContactsTrendRange] = useState("last_30_days");
    const [contactsTrendLoading, setContactsTrendLoading] = useState(true);
    const [contactsTrendError, setContactsTrendError] = useState(false);
    const [contactsTypeData, setContactsTypeData] = useState([]);
    const [contactsTypeCachedAt, setContactsTypeCachedAt] = useState("");
    const [contactsTypeRange, setContactsTypeRange] = useState("total");
    const [contactsTypeLoading, setContactsTypeLoading] = useState(true);
    const [contactsTypeError, setContactsTypeError] = useState(false);
    const [contactsTypeStartDate, setContactsTypeStartDate] = useState("");
    const [contactsTypeEndDate, setContactsTypeEndDate] = useState("");
    const [contactsTypeStartTime, setContactsTypeStartTime] = useState("");
    const [contactsTypeEndTime, setContactsTypeEndTime] = useState("");
    const [isChosenTypeCustomRange, setIsChosenTypeCustomRange] = useState(false);
    const [contactsValueMetricsRefresh, setContactsValueMetricsRefresh] = useState(false);
    const [contactsTrendMetricsRefresh, setContactsTrendMetricsRefresh] = useState(false);
    const [contactsTypeMetricsRefresh, setContactsTypeMetricsRefresh] = useState(false);
    const getContactsValue = invalidateCache => {
        setContactsValueLoading(true);
        if (contactsValueError)
            setContactsValueError(false);
        let startTime;
        let endTime;
        if (contactsValueRange === "custom" &&
            contactsValueStartDate !== "" &&
            contactsValueEndDate !== "") {
            if (contactsValueStartTime !== "") {
                startTime =
                    format(new Date(contactsValueStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(contactsValueStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(contactsValueStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (contactsValueEndTime !== "") {
                endTime =
                    format(new Date(contactsValueEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(contactsValueEndTime), "HH:mm:ss");
            }
            else {
                endTime = format(new Date(contactsValueEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("count", "contacts", contactsValueRange, undefined, undefined, undefined, undefined, undefined, invalidateCache ? 1 : undefined, contactsValueRange === "custom" ? startTime : undefined, contactsValueRange === "custom" ? endTime : undefined)
            .then(response => {
            setContactsValue(response.data.count);
            setContactsValueCachedAt(response.data.cached_at);
            setContactsValueLoading(false);
        })
            .catch(error => {
            setContactsValueError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setContactsValueLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getContactsTypeValues = invalidateCache => {
        setContactsTypeLoading(true);
        if (contactsTypeError)
            setContactsTypeError(false);
        let startTime;
        let endTime;
        if (contactsTypeRange === "custom" &&
            contactsTypeStartDate !== "" &&
            contactsTypeEndDate !== "") {
            if (contactsTypeStartTime !== "") {
                startTime =
                    format(new Date(contactsTypeStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(contactsTypeStartTime), "HH:mm:ss");
            }
            else {
                startTime = format(new Date(contactsTypeStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (contactsTypeEndTime !== "") {
                endTime =
                    format(new Date(contactsTypeEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(contactsTypeEndTime), "HH:mm:ss");
            }
            else {
                endTime = format(new Date(contactsTypeEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "contacts", contactsTypeRange, "type", undefined, undefined, undefined, undefined, invalidateCache ? 1 : undefined, contactsTypeRange === "custom" ? startTime : undefined, contactsTypeRange === "custom" ? endTime : undefined)
            .then(response => {
            let metricsData = [];
            response.data.data.map(d => {
                let color;
                if (d.label === "person") {
                    color = "28, 150, 243";
                }
                if (d.label === "business") {
                    color = "255, 152, 0";
                }
                if (d.label === "none") {
                    color = "158, 158, 158";
                }
                metricsData.push({ label: d.label, count: d.count, color: color });
            });
            setContactsTypeData(metricsData
                .sort(function (a, b) {
                return a.count - b.count;
            })
                .reverse());
            setContactsTypeCachedAt(response.data.cached_at);
            setContactsTypeLoading(false);
        })
            .catch(error => {
            setContactsTypeError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setContactsTypeLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getContactsTrendValues = invalidateCache => {
        setContactsTrendLoading(true);
        if (contactsTrendError)
            setContactsTrendError(false);
        let trendsLabels = getTrendLabels(contactsTrendRange);
        let labels = getLabels(trendsLabels, contactsTrendRange);
        setContactsTrendLabels(labels);
        let interval = contactsTrendRange;
        let startDate;
        let endDate;
        if (contactsTrendRange === "last_7_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 6), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        else if (contactsTrendRange === "last_30_days") {
            interval = "custom";
            startDate = format(subDays(new Date(), 29), "yyyy-MM-dd") + " 00:00:00";
            endDate = format(new Date(), "yyyy-MM-dd") + " 23:59:59";
        }
        api.GET_metrics("trend", "contacts", interval, undefined, undefined, undefined, undefined, undefined, invalidateCache ? 1 : undefined, startDate, endDate)
            .then(response => {
            let values = [];
            trendsLabels.map(label => {
                if (response.data.data.find(a => a.date === label)) {
                    values.push(response.data.data.find(a => a.date === label).count);
                }
                else {
                    values.push(0);
                }
            });
            setContactsTrendValues(values);
            setContactsTrendCachedAt(response.data.cached_at);
            setContactsTrendLoading(false);
        })
            .catch(error => {
            setContactsTrendError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setContactsTrendLoading(false);
            }
        });
        return () => api.cancel();
    };
    useEffect(() => {
        if (contactsValueRange !== "custom") {
            setContactsValueStartDate("");
            setContactsValueEndDate("");
            setContactsValueStartTime("");
            setContactsValueEndTime("");
            getContactsValue(undefined);
        }
    }, [contactsValueRange]);
    useEffect(() => {
        if (isChosenValueCustomRange &&
            contactsValueStartDate !== "" &&
            contactsValueEndDate !== "") {
            getContactsValue(undefined);
        }
    }, [isChosenValueCustomRange]);
    useEffect(() => {
        if (contactsTypeRange !== "custom") {
            setContactsTypeStartDate("");
            setContactsTypeEndDate("");
            setContactsTypeStartTime("");
            setContactsTypeEndTime("");
            getContactsTypeValues(undefined);
        }
    }, [contactsTypeRange]);
    // useEffect(() => {
    //     if (isChosenTypeCustomRange && contactsTypeStartDate !== "" && contactsTypeEndDate !== "") {
    //         getContactsTypeValues(undefined)
    //     }
    // }, [isChosenTypeCustomRange])
    useEffect(() => {
        getContactsTrendValues(undefined);
    }, [contactsTrendRange]);
    useEffect(() => {
        if (contactsTypeMetricsRefresh) {
            getContactsTypeValues(true);
            setContactsTypeMetricsRefresh(false);
        }
        if (contactsTrendMetricsRefresh) {
            getContactsTrendValues(true);
            setContactsTrendMetricsRefresh(false);
        }
        if (contactsValueMetricsRefresh) {
            getContactsValue(true);
            setContactsValueMetricsRefresh(false);
        }
    }, [contactsTrendMetricsRefresh, contactsTypeMetricsRefresh, contactsValueMetricsRefresh]);
    return (_jsx(Box, Object.assign({ sx: {
            marginBottom: 4,
        } }, { children: _jsxs(Grid, Object.assign({ container: true, spacing: 4 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 5, xl: 4 }, { children: _jsx(MetricValue, { title: t("contacts.contacts"), value: contactsValue, range: contactsValueRange, setRange: setContactsValuesRange, isLoading: contactsValueLoading, setIsLoading: setContactsValueLoading, cachedAt: contactsValueCachedAt, refresh: contactsValueMetricsRefresh, setRefresh: setContactsValueMetricsRefresh, startDate: contactsValueStartDate, setStartDate: setContactsValueStartDate, endDate: contactsValueEndDate, setEndDate: setContactsValueEndDate, startTime: contactsValueStartTime, setStartTime: setContactsValueStartTime, endTime: contactsValueEndTime, setEndTime: setContactsValueEndTime, setIsChosenCustomRange: setIsChosenValueCustomRange, isError: contactsValueError, color: metricColors[3] }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 7, xl: 8 }, { children: _jsx(MetricTrend, { title: t("contacts.metrics.contacts-trend"), label: t("contacts.contacts"), labels: contactsTrendLabels, values: contactsTrendValues, range: contactsTrendRange, setRange: setContactsTrendRange, isLoading: contactsTrendLoading, setIsLoading: setContactsTrendLoading, cachedAt: contactsTrendCachedAt, refresh: contactsTrendMetricsRefresh, setRefresh: setContactsTrendMetricsRefresh, isError: contactsTrendError, color: metricColors[3] }) }))] })) })));
}
